import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import { useAuth } from '../services/AuthContext'; // Importer le contexte Auth
import QuizResponse from './QuizResponse'; // Importer le composant QuizResponse
import { useTranslation } from 'react-i18next';
import { InfoCircleFill } from 'react-bootstrap-icons';

import '../css/Result.css';

const Result = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isUserAuthenticated } = useAuth();
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false); // État pour gérer la modal
  const [showLoginAlert, setShowLoginAlert] = useState(false); // État pour gérer l'alerte de connexion

  // Vérifiez si des réponses ont été transmises
  const { state } = location;
  const answers = state?.answers;
  const scoringValue = state?.scoringValue;
  const scanId = state?.scanId;
  // Rediriger si les données sont absentes
  useEffect(() => {
    if (!answers) navigate('/');

    setShowLoginAlert(!isUserAuthenticated);

  }, [answers, navigate, isUserAuthenticated]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <div>
      {showLoginAlert && (
        <div className="login-alert">
          You must log in to save your scan.
        </div>
      )}

      <QuizResponse
        scanId={(!isUserAuthenticated || !state.scanId) ? null : scanId} 
        scoringValue={scoringValue}
        answers={answers} 
        from="result" 
      />

      {/* Floating Button for Modal */}
      <Button 
        variant="link" 
        className={`open-modal-btn ${showLoginAlert ? "button-offset" : ""}`}
        onClick={toggleModal} 
        style={{ padding: 1 }}
      >
        <InfoCircleFill size={30} />
      </Button>

      {/* Bootstrap Modal for the Questions */}
      <Modal show={isModalOpen} onHide={toggleModal}>
        <Modal.Header>
          <Modal.Title>{t('scan.reflection.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li className="text-custom">{t('scan.reflection.line1')}</li><br />
            <li className="text-custom">{t('scan.reflection.line2')}</li><br />
            <li className="text-custom">{t('scan.reflection.line3')}</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={toggleModal}>
            {t('scan.reflection.close')}
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
  );
};

export default Result;
